import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin } from 'antd';
import moment from 'moment';
import { dataDefault, columnsData } from './data';
import imgSave from "../saveImg";
import Auth from "../Auth";
import TableText from "../TableText";
import Note from "./Note";
import getJson from "../../../method/getJson";

const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        const listName = ['actual', 'budget', 'lastYear'];
        listName.forEach(name => {
            data[2][name] = (data[1][name] * data[0][name]).toFixed(2);
            data[6][name] = (numConvert(data[5][name])
                + numConvert(data[4][name])
                + numConvert(data[3][name])
            ).toFixed(2);
        });

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;

        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);

        fetch(`/mettingInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }

            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addMeeting', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_1', 1.5, '0.10', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const numIndex = [2, 6];
        const columns = columnsData.map(item => {
            if (item.children) {
                return {
                    title: item.title,
                    children: item.children.map(v => {
                        return {
                            title: v.title,
                            dataIndex: v.key,
                            key: v.key,
                            width: 150,
                            align: "center",
                            render: (text, record, index) => {
                                const props = {
                                    text,
                                    index,
                                    type: index == 0 ? 'inputPercent' : numIndex.includes(index) ? 'number' : v.type,
                                    name: v.key,
                                    onChange: this.onChange,
                                    totalIndex: [6],
                                };
                                return (
                                    <TableText data={{ ...props }} />
                                )
                            }
                        }
                    })
                }
            }
            return {
                title: item.title,
                dataIndex: item.key,
                key: item.key,
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: item.type,
                        name: item.key,
                        onChange: this.onChange,
                        totalIndex: [6],
                    };
                    return (
                        <TableText data={{ ...props }} />
                    )
                }
            }
        });

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 tableHeight" >
                    <Row className="title" id="table9_1">
                        <Row>Meeting Flash Report 会议即时报表</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />

                            <span className="deadline">
                                <span>截止日期:</span>
                                <DatePicker
                                    placeholder="请选择截止日期"
                                    value={moment(getJson([0, 'deadline'], data, new Date()), "YYYY-MM-DD")}
                                    format="YYYY-MM-DD"
                                    onChange={(date, str) => {
                                        let d = [...data];
                                        d[0].deadline = str;
                                        this.setState({ data: d });
                                    }}
                                />
                            </span>

                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                        <Note
                            c="注：截止日期为ES会议前一天或者两天的数据。"
                            e="Note：The date should be one or two days before ES meeting."
                        />
                    </Row>

                    <Auth loading={this.state.loading} auth="edit_9_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入PDF</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/meetingFlash/index.js